module.exports = __webpack_public_path__ + "img/user.885ce1be.svg";